import api from 'config/api';

import * as LocalStorageService from './LocalStorageService';

const AUTH_HEADER = 'Authorization';

export const evaluateChange = (clientNumber, type) =>
  api.post('api/v1/procedures/change_ownership/evaluate', {
    client_number: clientNumber,
    type
  });

export const evaluateNewService = clientNumber =>
  api.post('api/v1/procedures/new_service/evaluate', {
    client_number: clientNumber
  });

export const evaluateTermination = (clientNumber, type) =>
  api.post('api/v1/procedures/cancel_service/evaluate', {
    client_number: clientNumber,
    type
  });

export const retrieveAccountData = clientNumber =>
  api.get('api/v1/procedures/account_data', {
    client_number: clientNumber
  });

export const retrieveTotalDebt = (clientNumber, newEP) =>
  api.get(`api/v1/procedures/${newEP ? 'new_service_debt' : 'complete_debt'}`, {
    client_number: clientNumber
  });

export const retrieveDueDebt = clientNumber =>
  api.get('api/v1/procedures/claimable_debt', { client_number: clientNumber });

export const createHolderChange = holderChangeData =>
  api.post('api/v1/procedures/change_ownership', holderChangeData);

export const createTerminationRequest = terminationRequestData =>
  api.post('api/v1/procedures/cancel_service', terminationRequestData);

export const getAccountHolderChange = procedureId =>
  api.get('api/v1/procedures/request_data', { request_number: procedureId });

export const getAccountProcedures = (clientNumber, type) =>
  api.post('api/v1/procedures/open_request', {
    client_number: clientNumber,
    type
  });

export const createNewService = newServiceData => api.post('api/v1/procedures/new_service', newServiceData);

export const cancelCustomProcedure = (procedureId, body) =>
  api.post('api/v1/procedures/cancel_request', { request_number: procedureId, body });

export const entitiesLogin = username => api.post('api/v1/procedures/entities/validation', username);

export const saveEntitySession = sessionToken => {
  LocalStorageService.removeSessionToken();
  api.setHeader(AUTH_HEADER, sessionToken);
};
